import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminUsersResponse, AdminUsersSearch } from '@models/models';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminUsersDataService {
	private ADMIN_URL = '/api/admin';

	constructor(private http: HttpClient) {}

	getUserSubscription(email: string) {
		const url = `${this.ADMIN_URL}/user/`;
		return this.http.post(url, email);
	}

	synchronize(): Observable<any> {
		const url = `${this.ADMIN_URL}/synchronize-admin-table-data`;
		return this.http.get(url);
	}

	deleteUser(email: string): Observable<any> {
		const url = `${this.ADMIN_URL}/user/delete`;
		const params: HttpParams = new HttpParams().append('userEmail', email);
		return this.http.delete(url, { params });
	}

	getUsers(data: AdminUsersSearch): Observable<AdminUsersResponse> {
		const url = `${this.ADMIN_URL}/get-admin-table-data`;
		return this.http.post(url, data).map((res: any) => res.data);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/services/admin/users/admin-users.data.service.ts